'use client';

import InlineStyle from '@/components/InlineStyle';
import HubSpotForm from '@/components/HubSpotForm';
import { Users, GraduationCap, BarChart3, TrendingUp, Wrench, LineChart, Trophy, Handshake, Package, Building2, Zap, Sprout, Link2, Network, Megaphone, UserCheck } from 'lucide-react';
import { useTranslation } from "@/hooks/useTranslation";
const PARTNER_ICONS = [{
  Icon: Users,
  label: 'Partner Ecosystem'
}, {
  Icon: GraduationCap,
  label: 'Dedicated Support'
}, {
  Icon: BarChart3,
  label: 'GTM Initiatives'
}, {
  Icon: TrendingUp,
  label: 'Revenue Growth'
}, {
  Icon: Wrench,
  label: 'Implementation'
}, {
  Icon: LineChart,
  label: 'Market Coverage'
}, {
  Icon: Trophy,
  label: 'Training & Certification'
}, {
  Icon: Handshake,
  label: 'Collaboration & Sales Approach'
}];
const WHY_PARTNER = [{
  Icon: Package,
  title: 'Expand Your Product Offering',
  desc: 'Be the advisor to your customer. Change the CX game for the customer with a cutting-edge Unified CX platform.'
}, {
  Icon: Building2,
  title: 'Solve For Customer Across Industries',
  desc: 'Use cases and extensive experience across industries to make this a winning proposition for you and the customer.'
}, {
  Icon: BarChart3,
  title: 'Advanced Social Listening & BI Dashboards',
  desc: 'Offer actionable insights to your customers through deep analysis across various social and digital channels.'
}, {
  Icon: Zap,
  title: 'Always Evolving',
  desc: 'We are not just pioneers, we are AI First Movers, recognized by Microsoft. Innovation is in our DNA.'
}, {
  Icon: Sprout,
  title: 'Grow Together',
  desc: 'Co-marketing and revenue share opportunities enable partners to jointly promote solutions and increase brand visibility.'
}, {
  Icon: Link2,
  title: 'Seamless Integrations',
  desc: 'Plug and Play integrations with various enterprise tools like CRM, collaboration tools, chatbots etc.'
}];
const JOURNEY_STEPS = [{
  n: '01',
  title: 'Connect & Explore Opportunities',
  desc: 'Let us start a conversation.'
}, {
  n: '02',
  title: 'Alignment & Strategic Fit',
  desc: 'Ensuring a win-win relationship.'
}, {
  n: '03',
  title: 'Onboarding & Enablement',
  desc: 'Empowering you for success.'
}, {
  n: '04',
  title: 'Go-to-Market Collaboration',
  desc: 'Launch and scale together.'
}, {
  n: '05',
  title: 'Continuous Support & Optimisation',
  desc: 'Ongoing growth and innovation.'
}, {
  n: '06',
  title: 'Joint Success & Expansion',
  desc: 'Evolving our partnership.'
}];
const EXISTING_PARTNERS = ['Microsoft', 'XSHIFT', 'Deloitte', 'Oracle', 'Servicenow', 'Infosys', 'Salesforce'];
const STATS = [{
  n: '350+',
  label: 'Enterprise Customers'
}, {
  n: '4.2 ★',
  label: 'Reviewed on G2'
}, {
  n: '40Bn',
  label: 'Data Points Processed'
}, {
  n: '4',
  label: 'Continents Presence'
}];
export default function PartnershipsPage() {
  const {
    t
  } = useTranslation();
  return <>
      {/* Hero */}
      <section style={{
      background: '#fff',
      position: 'relative',
      overflow: 'hidden',
      padding: '120px 0 80px'
    }}>
        <div className="lb-hero-grad" style={{
        position: 'absolute',
        inset: 0
      }} />
        <div className="container" style={{
        position: 'relative',
        zIndex: 1,
        textAlign: 'center'
      }}>
          <h1 className="lb-h1" style={{
          maxWidth: 640,
          margin: '0 auto 20px'
        }}>
            {t("partnerships.partner_with")}{' '}
            <span style={{
            background: 'linear-gradient(135deg,#0077FF,#5232FF)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>{t("partnerships.locobuzz")}</span>
          </h1>
          <p style={{
          fontSize: 17,
          color: '#4B5563',
          maxWidth: 560,
          margin: '0 auto 36px',
          lineHeight: 1.7
        }}>
            {t("partnerships.join_locobuzzs_partner_ecosystem_to")}
          </p>
          <div style={{
          display: 'flex',
          gap: 14,
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
            <a href="#partner-form" className="lb-btn-primary">{t("partnerships.become_a_partner")}</a>
            <a href="#partner-form" className="lb-btn-secondary">{t("partnerships.book_a_demo")}</a>
          </div>
        </div>
      </section>

      {/* Partner icons strip */}
      <section style={{
      background: '#F8FAFF',
      padding: '28px 0',
      borderTop: '1px solid #E5E7EB',
      borderBottom: '1px solid #E5E7EB'
    }}>
        <div className="container">
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 28,
          flexWrap: 'wrap'
        }}>
            {PARTNER_ICONS.map(({
            Icon,
            label
          }) => <div key={label} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 6,
            minWidth: 88
          }}>
                <span style={{
              width: 42,
              height: 42,
              borderRadius: 12,
              background: 'rgba(79,110,247,0.10)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#4F6EF7'
            }}>
                  <Icon size={20} strokeWidth={2.1} />
                </span>
                <span style={{
              fontSize: 11.5,
              fontWeight: 600,
              color: '#374151',
              textAlign: 'center',
              lineHeight: 1.3
            }}>{label}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Existing partners */}
      <section className="lb-section">
        <div className="container">
          <p style={{
          textAlign: 'center',
          fontSize: 13,
          fontWeight: 600,
          color: '#9CA3AF',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
          marginBottom: 20
        }}>{t("partnerships.existing_partners")}</p>
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 40,
          flexWrap: 'wrap'
        }}>
            {EXISTING_PARTNERS.map(p => <span key={p} style={{
            fontSize: 15,
            fontWeight: 700,
            color: '#374151'
          }}>{p}</span>)}
          </div>
        </div>
      </section>

      {/* Why partner */}
      <section className="lb-section-alt">
        <div className="container">
          <h2 className="lb-h2" style={{
          textAlign: 'center',
          marginBottom: 48
        }}>{t("partnerships.why_partner_with_locobuzz")}</h2>
          <div className="lb-grid-3">
            {WHY_PARTNER.map(({
            Icon,
            title,
            desc
          }, i) => <div key={i} style={{
            background: 'linear-gradient(135deg,#0051CC,#3A1FCC)',
            borderRadius: 14,
            padding: 24
          }}>
                <div style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: 'rgba(255,255,255,0.14)',
              border: '1px solid rgba(255,255,255,0.20)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              marginBottom: 14
            }}>
                  <Icon size={22} strokeWidth={2.1} />
                </div>
                {/* div not h3 — legacy.css forces h3 color: #172A4C !important, which would render the title dark on this blue card. */}
                <div style={{
              fontFamily: "'Inter',sans-serif",
              fontWeight: 700,
              fontSize: 15,
              color: '#fff',
              marginBottom: 8
            }}>{title}</div>
                <p style={{
              fontSize: 13,
              color: 'rgba(255,255,255,0.7)',
              lineHeight: 1.65
            }}>{desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="lb-section">
        <div className="container">
          <h2 className="lb-h2" style={{
          textAlign: 'center',
          marginBottom: 40
        }}>{t("partnerships.a_partner_program_for_all_businesse")}</h2>
          <div className="partner-stats-grid" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 28,
          alignItems: 'center'
        }}>
            <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 10,
            height: 220,
            borderRadius: 16,
            overflow: 'hidden'
          }}>
              {[...Array(6)].map((_, i) => <div key={i} style={{
              background: '#F3F4F6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}>
                  <img src={`https://images.unsplash.com/photo-${['1600880292203-757bb62b4baf', '1507003211169-0a1dd7228f2d', '1494790108377-be9c29b29330', '1587825140708-dfaf72ae4b04', '1556745757-8d76bdb6984b', '1600880292089-90a7e086ee0c'][i]}?w=200&q=70`} alt="" loading="lazy" decoding="async" style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }} />
                </div>)}
            </div>
            <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16
          }}>
              {STATS.map(s => <div key={s.n} style={{
              background: 'linear-gradient(135deg,#0051CC,#3A1FCC)',
              borderRadius: 12,
              padding: 20,
              textAlign: 'center'
            }}>
                  <div style={{
                fontFamily: "'Inter',sans-serif",
                fontSize: 28,
                fontWeight: 900,
                color: '#fff',
                marginBottom: 6
              }}>{s.n}</div>
                  <div style={{
                fontSize: 12,
                color: 'rgba(255,255,255,0.7)'
              }}>{s.label}</div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Partner Journey */}
      <section className="lb-section-alt">
        <div className="container">
          <h2 className="lb-h2" style={{
          textAlign: 'center',
          marginBottom: 8
        }}>{t("partnerships.partner_journey")}</h2>
          <p style={{
          textAlign: 'center',
          fontSize: 14,
          color: '#6B7280',
          marginBottom: 40
        }}>{t("partnerships.how_we_collaborate_for_mutual_succe")}</p>
          <div className="partner-journey-row" style={{
          display: 'flex',
          gap: 0,
          position: 'relative',
          overflowX: 'auto'
        }}>
            <div className="partner-journey-line" style={{
            position: 'absolute',
            top: 24,
            left: '5%',
            right: '5%',
            height: 2,
            background: 'linear-gradient(to right,#0077FF,#5232FF)',
            zIndex: 0
          }} />
            {JOURNEY_STEPS.map((step, i) => <div key={i} style={{
            flex: 1,
            minWidth: 120,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            zIndex: 1,
            padding: '0 8px'
          }}>
                <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: `hsl(${200 + i * 15},80%,${40 + i * 3}%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontWeight: 800,
              fontSize: 13,
              marginBottom: 12,
              border: '3px solid #fff',
              boxShadow: '0 0 0 2px #0077FF'
            }}>{step.n}</div>
                <div style={{
              fontSize: 12,
              fontWeight: 700,
              color: '#111827',
              textAlign: 'center',
              marginBottom: 4
            }}>{step.title}</div>
                <div style={{
              fontSize: 11,
              color: '#6B7280',
              textAlign: 'center'
            }}>{step.desc}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* HubSpot Contact Form — single clean section */}
      <section id="partner-form" style={{
      background: '#fff',
      padding: 'var(--section-pad)'
    }}>
        <div className="container">
          <div className="partner-form-grid" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 64,
          alignItems: 'start'
        }}>
            <div>
              <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              padding: '5px 14px',
              borderRadius: 100,
              border: '1px solid rgba(79,110,247,0.3)',
              background: 'rgba(79,110,247,0.07)',
              fontSize: 12,
              fontWeight: 500,
              color: '#4F6EF7',
              fontFamily: "'Inter Tight',sans-serif",
              marginBottom: 16
            }}>
                <span style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: '#4F6EF7',
                flexShrink: 0
              }} />{t("partnerships.partner_with_us")}
              </span>
              <h2 style={{
              fontFamily: "'Inter Tight',sans-serif",
              fontWeight: 500,
              fontSize: 'clamp(26px,3.5vw,40px)',
              color: '#0D1117',
              lineHeight: 1.1,
              letterSpacing: '-0.025em',
              marginBottom: 20
            }}>
                {t("partnerships.lets_build_something_great_together")}
              </h2>
              <p style={{
              fontSize: 16,
              color: '#64748B',
              lineHeight: 1.75,
              fontFamily: "'Inter Tight',sans-serif",
              marginBottom: 28
            }}>
                {t("partnerships.whether_youre_a_technology_provider")}
              </p>
              <ul style={{
              listStyle: 'none',
              padding: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 14
            }}>
                {[{
                Icon: Network,
                label: 'Access to 1200+ enterprise brand network'
              }, {
                Icon: Megaphone,
                label: 'Co-marketing and joint GTM support'
              }, {
                Icon: UserCheck,
                label: 'Dedicated partner success manager'
              }, {
                Icon: TrendingUp,
                label: 'Revenue sharing and deal registration'
              }].map(({
                Icon,
                label
              }, i) => <li key={i} style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                fontFamily: "'Inter Tight',sans-serif",
                fontSize: 14.5,
                color: '#1F2937'
              }}>
                    <span style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: 'linear-gradient(135deg,rgba(79,110,247,0.12),rgba(108,71,245,0.08))',
                  border: '1px solid rgba(79,110,247,0.18)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                      <Icon size={16} color="#4F6EF7" strokeWidth={2.2} />
                    </span>
                    <span style={{
                  flex: 1,
                  lineHeight: 1.45
                }}>{label}</span>
                  </li>)}
              </ul>
            </div>
            <div style={{
            background: '#F8FAFF',
            borderRadius: 20,
            padding: 32,
            border: '1px solid #E8ECF4',
            boxShadow: '0 8px 48px rgba(79,110,247,0.08)'
          }}>
              {/* div not h3 — legacy.css forces h3 color and would override the inline style. */}
              <div style={{
              fontFamily: "'Inter Tight',sans-serif",
              fontWeight: 700,
              fontSize: 20,
              color: '#0D1117',
              marginBottom: 6
            }}>{t("partnerships.get_in_touch")}</div>
              <p style={{
              fontSize: 13,
              color: '#64748B',
              fontFamily: "'Inter Tight',sans-serif",
              marginBottom: 20
            }}>{t("partnerships.tell_us_about_your_company_and_part")}</p>
              <HubSpotForm formName="partnerships" eager />
            </div>
          </div>
        </div>
        <InlineStyle css={`
          @media (max-width: 820px) {
            .partner-form-grid {
              grid-template-columns: 1fr !important;
              gap: 36px !important;
            }
            .partner-stats-grid {
              grid-template-columns: 1fr !important;
              gap: 24px !important;
            }
            /* Partner Journey: hide the connecting line on mobile (it
               misaligns when steps wrap) and let the steps wrap to 2
               columns instead of overflow-scrolling. */
            .partner-journey-row {
              flex-wrap: wrap !important;
              overflow-x: visible !important;
              row-gap: 28px !important;
            }
            .partner-journey-row > div { flex: 0 0 50% !important; min-width: 0 !important; }
            .partner-journey-line { display: none !important; }
          }
        `} />
      </section>
    </>;
}